import React from "react";

export function UtensilsIcon(
  props: React.SVGProps<SVGSVGElement> & { color: string },
): React.ReactElement {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_25_3081)">
        <path
          d="M11.9999 1V7C11.9985 8.1522 11.5998 9.26868 10.8712 10.1613C10.1426 11.0538 9.1285 11.6679 7.99991 11.9V23C7.99991 23.2652 7.89455 23.5196 7.70702 23.7071C7.51948 23.8946 7.26512 24 6.99991 24C6.73469 24 6.48034 23.8946 6.2928 23.7071C6.10527 23.5196 5.99991 23.2652 5.99991 23V11.9C4.87132 11.6679 3.85725 11.0538 3.12863 10.1613C2.4 9.26868 2.00136 8.1522 1.99991 7V1C1.99991 0.734784 2.10527 0.48043 2.2928 0.292893C2.48034 0.105357 2.73469 0 2.99991 0C3.26512 0 3.51948 0.105357 3.70702 0.292893C3.89455 0.48043 3.99991 0.734784 3.99991 1V7C4.00247 7.61826 4.19599 8.22063 4.554 8.7247C4.912 9.22877 5.417 9.60992 5.99991 9.816V1C5.99991 0.734784 6.10527 0.48043 6.2928 0.292893C6.48034 0.105357 6.73469 0 6.99991 0C7.26512 0 7.51948 0.105357 7.70702 0.292893C7.89455 0.48043 7.99991 0.734784 7.99991 1V9.816C8.58282 9.60992 9.08782 9.22877 9.44582 8.7247C9.80382 8.22063 9.99735 7.61826 9.99991 7V1C9.99991 0.734784 10.1053 0.48043 10.2928 0.292893C10.4803 0.105357 10.7347 0 10.9999 0C11.2651 0 11.5195 0.105357 11.707 0.292893C11.8946 0.48043 11.9999 0.734784 11.9999 1ZM21.9999 10C21.9552 11.9004 21.4824 13.7663 20.6167 15.4587C19.751 17.1512 18.5147 18.6265 16.9999 19.775V23C16.9999 23.2652 16.8946 23.5196 16.707 23.7071C16.5195 23.8946 16.2651 24 15.9999 24C15.7347 24 15.4803 23.8946 15.2928 23.7071C15.1053 23.5196 14.9999 23.2652 14.9999 23V2C14.9909 1.62426 15.0936 1.25431 15.2949 0.936929C15.4963 0.619551 15.7872 0.369011 16.1309 0.217C16.5258 0.0563652 16.9588 0.0142302 17.3772 0.0957442C17.7956 0.177258 18.1812 0.378891 18.4869 0.676C20.8063 3.22095 22.0633 6.5573 21.9999 10ZM19.9999 10C20.0283 7.07215 18.9578 4.24008 16.9999 2.063V17.07C18.874 15.1882 19.9488 12.6553 19.9999 10Z"
          fill={props.color}
        />
      </g>
      <defs>
        <clipPath id="clip0_25_3081">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
